import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => (
    <div>
        404! <Link to="/">Go Home</Link>
    </div>
);

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/PageNotFound.js